import './App.css';
import Home from "./pages/Home";
import Services from './pages/Services';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AccessibilityPolicy from './pages/AccessibilityPolicy';
import BillOfRights from './pages/BillOfRights';
import BookingForm from './pages/BookingForm';
import Calendar from './pages/Calendar';
import AboutUs from './pages/AboutUs';
import OurTeam from './pages/OurTeam';
import Connect from './pages/Connect';
import Career from './pages/Career';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserProvider } from './context/UserContext';

import HomeChinese from './pages/HomeChinese';
import ServicesChinese from './pages/ServicesChinese';
import BookingFormChinese from './pages/BookingFormChinese';
import CalendarChinese from './pages/CalendarChinese';
import AboutUsChinese from './pages/AboutUsChinese';
import OurTeamChinese from './pages/OurTeamChinese';
import ConnectChinese from './pages/ConnectChinese';
import CareerChinese from './pages/CareerChinese';

// Pages for backend
import Login from './pages/backend/Login';
import Create from './pages/backend/Create';
import PatientDashboard from './pages/backend/PatientDashboard';
import ServiceWorkerDashboard from './pages/backend/ServiceWorkerDashboard';
import AdminDashboard from './pages/backend/AdminDashboard';
import Report from './pages/backend/Report';
import AdminReports from './pages/backend/AdminReports';
import CreatePSW from './pages/backend/CreatePSW';
import ViewAllUsers from './pages/backend/ViewAllUsers';
import OpenAppointments from './pages/backend/OpenAppointments';

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "/backend";

function App() {

  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/services" element={<Services />} />
          <Route path="/" element={<Home />} />
          <Route path="/bookingform" element={<BookingForm />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/accessibility" element={<AccessibilityPolicy />} />
          <Route path="/bill-of-rights" element={<BillOfRights />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/ourteam" element={<OurTeam />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/career" element={<Career />} />

          <Route path="/zh" element={<HomeChinese />} />
          <Route path="/zhservices" element={<ServicesChinese />} />
          <Route path="/zhbookingform" element={<BookingFormChinese />} />
          <Route path="/zhcalendar" element={<CalendarChinese />} />
          <Route path="/zhaboutus" element={<AboutUsChinese />} />
          <Route path="/zhourteam" element={<OurTeamChinese />} />
          <Route path="/zhconnect" element={<ConnectChinese />} />
          <Route path="/zhcareer" element={<CareerChinese />} />

          <Route path={`${FRONTEND_URL}/login`} element={<Login />} />
          <Route path={`${FRONTEND_URL}/create`} element={<Create />} />
          <Route path={`${FRONTEND_URL}/dashboard`} element={<PatientDashboard />} />
          <Route path={`${FRONTEND_URL}/service-worker-dashboard`} element={<ServiceWorkerDashboard />} />
          <Route path={`${FRONTEND_URL}/admin-dashboard`} element={<AdminDashboard />} />
          <Route path={`${FRONTEND_URL}/report`} element={<Report />} />
          <Route path={`${FRONTEND_URL}/admin-reports`} element={<AdminReports />} />
          <Route path={`${FRONTEND_URL}/create-psw`} element={<CreatePSW />} />
          <Route path={`${FRONTEND_URL}/view-users`} element={<ViewAllUsers />} />
          <Route path={`${FRONTEND_URL}/open-appointments`} element={<OpenAppointments />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App; 